import { useQuery } from "@tanstack/react-query"
import { fetchServerDate, fetchSupplierById, fetchUsername, fetchAllClients, fetchSupplierUsers } from "../services/reviewForAuth.service"

export const useReviewForAuthData = ({ id, userLogged }) => {
	const enabled = !!id && !!userLogged

	const { data: serverDate } = useQuery({
		queryKey: ['serverDate'],
		queryFn: fetchServerDate,
		enabled,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	})

	const { data: supplierData } = useQuery({
		queryKey: ['supplier-reviewForAuth', id],
		queryFn: () => fetchSupplierById(id, { dataID: userLogged?.dataID, rol: userLogged?.rol }),
		enabled,
		staleTime: 0,
		refetchOnWindowFocus: false,
	})

	const { data: clients } = useQuery({
		queryKey: ['clients-reviewForAuth'],
		queryFn: fetchAllClients,
		enabled,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	})

	const { data: usersData } = useQuery({
		queryKey: ['supplierUsers-reviewForAuth', id],
		queryFn: () => fetchSupplierUsers(id),
		enabled,
		staleTime: 0,
		refetchOnWindowFocus: false,
	})

	const { data: username } = useQuery({
		queryKey: ['username-reviewForAuth', id],
		queryFn: () => fetchUsername(id),
		enabled,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
	})

	const isLoading = !supplierData || !serverDate || !clients

	return { supplierData, serverDate, clients, users: usersData ?? [], username, isLoading }
}
